import { AxiosRequestConfig } from "axios";

import { createApiQueryHook } from "@sol/sdk/utils/api";

import { ICurrentBrandResource } from "../types/ICurrentBrandResource";

export type ICurrentBrandQueryResult = ICurrentBrandResource;

export const currentBrandQuery = (): AxiosRequestConfig => {
    return {
        method: "GET",
        url: "/current_brand/self",
    };
};

export const useCurrentBrandQuery = createApiQueryHook<unknown, ICurrentBrandQueryResult>(currentBrandQuery);
